<template>
  <div
    id="kt_app_sidebar_footer"
    class="app-sidebar-footer"
    data-kt-app-footer-fixed="true"
  >
    <div
      class="d-flex flex-column"
      v-if="
        this.user && this.user.User && this.user.User.Emitente.tipo_pacote == 0
      "
    >
      <button
        data-bs-toggle="modal"
        data-bs-target="#kt_modal_upgrade_plan"
        type="button"
        class="btn btn-custom btn-active-color-white ms-5 me-5 mb-5"
      >
        <span class="svg-icon svg-icon-1 lh-0 btn-icon ps-2">
          <inline-svg src="media/icons/duotune/general/gen002.svg" />
        </span>
        <div class="btn-label">
          <span class="svg-icon svg-icon-1 lh-0 me-2">
            <inline-svg src="media/icons/duotune/general/gen002.svg" /> </span
          >Atualizar Plano
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { mapState } from "vuex";

export default defineComponent({
  name: "sidebar-footer",
  components: {},
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {},
  data() {
    return {};
  },
});
</script>
